var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationPin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 15.625C3.625 13.5938 0 8.75 0 6C0 2.6875 2.65625 0 6 0C9.3125 0 12 2.6875 12 6C12 8.75 8.34375 13.5938 6.71875 15.625C6.34375 16.0938 5.625 16.0938 5.25 15.625ZM10 7.8125C10.3438 7 10.5 6.40625 10.5 6C10.5 3.53125 8.46875 1.5 6 1.5C3.5 1.5 1.5 3.53125 1.5 6C1.5 6.40625 1.625 7 1.96875 7.8125C2.28125 8.5625 2.75 9.4375 3.28125 10.3125C4.1875 11.75 5.21875 13.125 6 14.125C6.75 13.125 7.78125 11.75 8.6875 10.3125C9.21875 9.4375 9.6875 8.5625 10 7.8125Z",
    fill: "#404040"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationPin);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxMiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuMjUgMTUuNjI1QzMuNjI1IDEzLjU5MzggMCA4Ljc1IDAgNkMwIDIuNjg3NSAyLjY1NjI1IDAgNiAwQzkuMzEyNSAwIDEyIDIuNjg3NSAxMiA2QzEyIDguNzUgOC4zNDM3NSAxMy41OTM4IDYuNzE4NzUgMTUuNjI1QzYuMzQzNzUgMTYuMDkzOCA1LjYyNSAxNi4wOTM4IDUuMjUgMTUuNjI1Wk0xMCA3LjgxMjVDMTAuMzQzOCA3IDEwLjUgNi40MDYyNSAxMC41IDZDMTAuNSAzLjUzMTI1IDguNDY4NzUgMS41IDYgMS41QzMuNSAxLjUgMS41IDMuNTMxMjUgMS41IDZDMS41IDYuNDA2MjUgMS42MjUgNyAxLjk2ODc1IDcuODEyNUMyLjI4MTI1IDguNTYyNSAyLjc1IDkuNDM3NSAzLjI4MTI1IDEwLjMxMjVDNC4xODc1IDExLjc1IDUuMjE4NzUgMTMuMTI1IDYgMTQuMTI1QzYuNzUgMTMuMTI1IDcuNzgxMjUgMTEuNzUgOC42ODc1IDEwLjMxMjVDOS4yMTg3NSA5LjQzNzUgOS42ODc1IDguNTYyNSAxMCA3LjgxMjVaIiBmaWxsPSIjNDA0MDQwIi8+Cjwvc3ZnPgo=";